import React from "react";
import {
  getAppraisalCycleList,
  getActiveAppraisalCycle,
} from "../../actions/AppraisalCycleAction";
import { getSelectedCycleId, setSelectedCycleId } from "../../utils";

// Global appraisal-cycle switcher shown in the APAR topbar. The chosen cycle id
// is persisted to localStorage and auto-injected into cycle-scoped API calls
// (see withSelectedCycle in AppraisalCycleAction). This is what lets multiple
// cycles run in parallel without data mismatch: every screen reads/writes
// against the cycle selected here.
//
// On first load (nothing selected yet) it defaults to the active cycle, so the
// behaviour is identical to before until the user explicitly switches.
class CycleSelector extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      cycleList: [],
      selectedCycleId: getSelectedCycleId(),
    };
  }

  // Only active on APAR screens. PrivateRoute (where this is also mounted) wraps
  // non-APAR pages too, so skip fetching/rendering anywhere outside /apar.
  isAparScreen = (): boolean => {
    try {
      return window.location.pathname.indexOf("/apar") > -1;
    } catch (e) {
      return false;
    }
  };

  componentDidMount() {
    if (!this.isAparScreen()) return;
    getAppraisalCycleList()
      .then((res: any) => {
        const list = (res?.result || []).filter((c: any) => {
          const status = (c.status || "").toLowerCase();
          return status === "active" || status === "draft";
        });
        this.setState({ cycleList: list });

        // No cycle selected yet -> default to the active one so existing flows
        // keep working unchanged.
        if (!getSelectedCycleId()) {
          getActiveAppraisalCycle()
            .then((activeRes: any) => {
              const activeId = activeRes?.result?.id;
              if (activeId != null) {
                setSelectedCycleId(activeId);
                this.setState({ selectedCycleId: String(activeId) });
              }
            })
            .catch(() => {});
        }
      })
      .catch(() => {});
  }

  onChange = (e: any) => {
    const id = e.target.value;
    setSelectedCycleId(id);
    this.setState({ selectedCycleId: id });
    // Reload so every screen refetches its data scoped to the new cycle.
    // There is no global store/event bus in this app, so a reload is the
    // simplest reliable way to re-scope all open data.
    window.location.reload();
  };

  render() {
    const { cycleList, selectedCycleId } = this.state;
    if (!cycleList || cycleList.length === 0) {
      return null;
    }
    return (
      <li className="nav-item d-flex align-items-center me-2">
        <i
          className="fa fa-calendar"
          style={{ color: "#cbd5e1", marginRight: "6px", fontSize: "13px" }}
        />
        <select
          value={selectedCycleId}
          onChange={this.onChange}
          title="Active appraisal cycle"
          style={{
            background: "#1f2937",
            color: "#fff",
            border: "1px solid #374151",
            borderRadius: "6px",
            fontSize: "12px",
            padding: "5px 8px",
            maxWidth: "260px",
          }}
        >
          <option value="">-- Select Cycle --</option>
          {cycleList.map((cycle: any) => (
            <option key={cycle.id} value={cycle.id}>
              {cycle.cycle_name || cycle.cycleName || `Cycle #${cycle.id}`}
              {cycle.status ? ` (${cycle.status})` : ""}
            </option>
          ))}
        </select>
      </li>
    );
  }
}

export default CycleSelector;
